(function () {
  var ORTE = { de: "de-DE", en: "en-AU", en_us: "en-US", sv: "sv-SE", fr: "fr-FR" };
  var NOT = {
    de: { fehler_technik: "Die Sendungsdaten sind gerade nicht erreichbar. Bitte versuch es gleich noch einmal." },
    en: { fehler_technik: "Tracking details aren't available right now. Please try again shortly." }
  };
  var HAKEN = '<svg viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M2.5 6.2l2.3 2.3 4.7-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function fuellen(t, w) {
    return String(t || "").replace(/\{([a-z_]+)\}/g, function (m, k) { return w[k] != null ? w[k] : m; });
  }

  function mailLink(text, mail) {
    if (!mail) return esc(text);
    var teile = String(text).split(mail);
    return teile.map(esc).join('<a href="mailto:' + esc(mail) + '">' + esc(mail) + "</a>");
  }

  function zeitText(iso, sprache) {
    var d = new Date(iso);
    if (isNaN(d)) return { tag: iso, uhr: "" };
    var ort = ORTE[sprache] || "de-DE";
    try {
      return {
        tag: new Intl.DateTimeFormat(ort, { day: "numeric", month: "short" }).format(d),
        uhr: new Intl.DateTimeFormat(ort, { hour: "2-digit", minute: "2-digit" }).format(d)
      };
    } catch (e) {
      return { tag: iso.slice(0, 10), uhr: iso.slice(11, 16) };
    }
  }

  function paketHtml(p, daten, ui) {
    var h = "";
    h += '<div class="sv-status" aria-live="polite">';
    h += '<h2 class="sv-status-titel">' + esc(p.titel) + "</h2>";
    if (p.eta) {
      var label = p.eta.art === "zugestellt" ? ui.zugestellt_am : ui.voraussichtlich;
      h += '<p class="sv-eta">' + esc(label) + "<strong>" + esc(p.eta.text) + "</strong></p>";
    }
    if (p.text) h += '<p class="sv-status-text">' + mailLink(p.text, daten.support) + "</p>";
    h += '<ol class="sv-schritte">';
    p.schritte.forEach(function (s, i) {
      var klasse = "sv-schritt";
      if (s.erreicht) klasse += " ist-erreicht";
      if (i === p.stufe - 1 && p.stufe < 5) klasse += " ist-aktuell";
      if (i === p.stufe && p.stufe < 5 && p.phase !== "problem" && p.phase !== "retour") klasse += " ist-naechster";
      h += '<li class="' + klasse + '"><span class="sv-punkt">' + HAKEN + '</span><span class="sv-schritt-name">' + esc(s.name) + "</span>";
      h += '<span class="sv-schritt-datum">' + esc(s.datum || "") + "</span></li>";
    });
    h += "</ol></div>";

    if (p.balken) {
      var b = p.balken;
      var voll = Math.max(0, Math.min(1, b.heute)) * 100;
      h += '<div class="sv-zeit">' + (b.zeile ? "<p>" + esc(b.zeile) + "</p>" : "");
      h += '<div class="sv-zeit-bahn" aria-hidden="true">';
      h += '<span class="sv-zeit-fenster" style="left:' + (b.von * 100).toFixed(2) + "%;width:" + ((b.bis - b.von) * 100).toFixed(2) + '%"></span>';
      h += '<span class="sv-zeit-voll" style="width:' + voll.toFixed(2) + '%"></span>';
      h += '<span class="sv-zeit-marke" style="left:' + voll.toFixed(2) + '%"></span>';
      h += "</div>";
      var mitte = ((b.von + b.bis) / 2) * 100;
      var ausrichtung = mitte > 80 ? "right:0" : "left:" + mitte.toFixed(2) + "%;transform:translateX(-50%)";
      h += '<div class="sv-zeit-enden"><span>' + esc(b.links) + '</span><span class="sv-zeit-fenstername" style="' + ausrichtung + '">' + esc(b.rechts) + "</span></div></div>";
    }

    if (p.spaet) h += '<p class="sv-spaet">' + mailLink(p.spaet, daten.support) + "</p>";

    (p.notizen || []).forEach(function (n) {
      h += '<div class="sv-nachricht"><strong>' + esc(fuellen(ui.nachricht_von, { marke: daten.marke })) + "</strong>";
      h += "<span>" + esc(n.datum || "") + "</span><p>" + esc(n.text) + "</p></div>";
    });

    h += '<div class="sv-abschnitt"><h3>' + esc(ui.verlauf) + "</h3>";
    if (p.zusteller && p.zusteller.nummer) {
      h += '<div class="sv-zusteller"><div><span>' + esc(fuellen(ui.zustellnummer, { zusteller: p.zusteller.name })) + "</span><b>" + esc(p.zusteller.nummer) + "</b></div>";
      if (p.zusteller.link) h += '<a href="' + esc(p.zusteller.link) + '" target="_blank" rel="noopener">' + esc(fuellen(ui.beim_zusteller_ansehen, { zusteller: p.zusteller.name })) + "</a>";
      h += "</div>";
    } else if (p.ursprungsnummer) {
      h += '<div class="sv-zusteller"><div><span>' + esc(ui.sendungsnummer) + "</span><b>" + esc(p.ursprungsnummer) + "</b></div></div>";
    }
    if (!p.verlauf || !p.verlauf.length) {
      h += '<p class="sv-leer" style="margin-top:14px">' + esc(ui.keine_eintraege) + "</p>";
    } else {
      h += '<ol class="sv-verlauf" style="margin-top:18px">';
      p.verlauf.forEach(function (e, i) {
        var z = zeitText(e.zeit, daten.sprache);
        h += '<li class="sv-eintrag"' + (i >= 5 ? " hidden data-mehr" : "") + '><div class="sv-eintrag-zeit">' + esc(z.tag) + "<br>" + esc(z.uhr) + "</div>";
        h += '<div class="sv-eintrag-inhalt">' + esc(e.text) + (e.ort ? '<span class="sv-eintrag-ort">' + esc(e.ort) + "</span>" : "") + "</div></li>";
      });
      h += "</ol>";
      if (p.verlauf.length > 5) h += '<button type="button" class="sv-mehr" data-umschalten aria-expanded="false">' + esc(ui.alle_eintraege) + "</button>";
    }
    h += "</div>";

    if (p.vorschau && p.vorschau.length) {
      h += '<div class="sv-abschnitt sv-vorschau"><h3>' + esc(p.vorschau_titel) + "</h3>";
      h += '<p class="sv-vorschau-hinweis">' + esc(p.vorschau_hinweis) + "</p>";
      h += '<ol class="sv-vorschau-liste">';
      p.vorschau.forEach(function (v) {
        h += '<li><span class="sv-vorschau-name">' + esc(v.name) + "</span>" + (v.zeitraum ? '<span class="sv-vorschau-zeit">' + esc(v.zeitraum) + "</span>" : "") + "</li>";
      });
      h += "</ol></div>";
    }
    return h;
  }

  function ergebnisHtml(daten) {
    var ui = daten.ui;
    var h = '<div class="sv-ergebnis">';
    h += '<div class="sv-bestellung"><h2>' + (daten.bestellung.nummer ? esc(ui.bestellung + " " + daten.bestellung.nummer) : esc(daten.marke)) + "</h2>";
    var zeile = [ui.bestellt_am + " " + daten.bestellung.datum];
    if (daten.bestellung.ziel) zeile.push(ui.lieferung_nach + " " + daten.bestellung.ziel);
    h += "<p>" + esc(zeile.join(" · ")) + "</p></div>";
    if (daten.banner) h += '<p class="sv-banner">' + esc(daten.banner) + "</p>";
    if (daten.pakete.length > 1) {
      h += '<div class="sv-reiter" role="tablist">';
      daten.pakete.forEach(function (p, i) {
        h += '<button type="button" role="tab" data-paket="' + i + '" aria-selected="' + (i === 0) + '">' + esc(ui.paket + " " + (i + 1)) + "</button>";
      });
      h += "</div>";
    }
    daten.pakete.forEach(function (p, i) {
      h += '<div class="sv-paket" data-paket-inhalt="' + i + '"' + (i > 0 ? " hidden" : "") + ">" + paketHtml(p, daten, ui) + "</div>";
    });
    if (daten.artikel && daten.artikel.length) {
      h += '<div class="sv-abschnitt"><h3>' + esc(ui.inhalt) + '</h3><ul class="sv-artikel">';
      daten.artikel.forEach(function (a) {
        h += "<li>" + (a.bild ? '<img src="' + esc(a.bild) + '" alt="" loading="lazy" width="56" height="56">' : '<span class="sv-bild-leer"></span>');
        h += '<span class="sv-artikel-name">' + esc(a.titel) + '</span><span class="sv-artikel-menge">' + esc(ui.menge) + " " + esc(a.menge) + "</span></li>";
      });
      h += "</ul></div>";
    }
    if (daten.support) h += '<p class="sv-hilfe">' + mailLink(fuellen(ui.hilfe, { support: daten.support }), daten.support) + "</p>";
    h += "</div>";
    return h;
  }

  function verdrahten(box, ui) {
    box.querySelectorAll("[data-umschalten]").forEach(function (knopf) {
      knopf.addEventListener("click", function () {
        var liste = knopf.previousElementSibling;
        var auf = knopf.getAttribute("aria-expanded") === "true";
        liste.querySelectorAll("[data-mehr]").forEach(function (li) { li.hidden = auf; });
        knopf.setAttribute("aria-expanded", String(!auf));
        knopf.textContent = auf ? ui.alle_eintraege : ui.weniger_eintraege;
      });
    });
    box.querySelectorAll("[data-paket]").forEach(function (reiter) {
      reiter.addEventListener("click", function () {
        var i = reiter.getAttribute("data-paket");
        box.querySelectorAll("[data-paket]").forEach(function (r) { r.setAttribute("aria-selected", String(r === reiter)); });
        box.querySelectorAll("[data-paket-inhalt]").forEach(function (el) { el.hidden = el.getAttribute("data-paket-inhalt") !== i; });
      });
    });
  }

  window.SendungsverfolgungDarstellen = function (box, daten) {
    box.innerHTML = ergebnisHtml(daten);
    verdrahten(box, daten.ui);
  };

  function start(wurzel) {
    var api = (wurzel.getAttribute("data-api") || "").replace(/\/$/, "");
    var seitenSprache = wurzel.getAttribute("data-sprache") || document.documentElement.lang || "de";
    var markt = wurzel.getAttribute("data-markt") || "";
    var kopf = wurzel.querySelector("[data-kopf]");
    var form = wurzel.querySelector("[data-form]");
    var ergebnis = wurzel.querySelector("[data-ergebnis]");
    var ui = null;
    var params = new URLSearchParams(location.search);

    function notText(k) {
      var s = seitenSprache.slice(0, 2) === "de" ? "de" : "en";
      return (ui && ui[k]) || NOT[s][k] || NOT.en[k];
    }

    function laden() {
      ergebnis.hidden = false;
      ergebnis.innerHTML = '<div class="sv-laden" role="status"><span></span><span></span><span></span></div>';
    }

    function formZeigen(fehler, feld) {
      kopf.hidden = false;
      form.hidden = false;
      ergebnis.hidden = true;
      var meldung = form.querySelector("[data-meldung]");
      form.querySelectorAll("input").forEach(function (i) { i.removeAttribute("aria-invalid"); });
      if (fehler) {
        meldung.textContent = fehler;
        meldung.hidden = false;
        if (feld) {
          var el = form.querySelector('[name="' + feld + '"]');
          if (el) { el.setAttribute("aria-invalid", "true"); el.focus(); }
        }
      } else {
        meldung.hidden = true;
      }
    }

    function zeigen(daten) {
      kopf.hidden = true;
      form.hidden = true;
      ergebnis.hidden = false;
      window.SendungsverfolgungDarstellen(ergebnis, daten);
      var neu = document.createElement("button");
      neu.type = "button";
      neu.className = "sv-knopf sv-knopf-leise sv-neu";
      neu.textContent = daten.ui.neue_suche;
      neu.addEventListener("click", function () {
        history.replaceState(null, "", location.pathname);
        form.reset();
        formZeigen();
        window.scrollTo({ top: wurzel.getBoundingClientRect().top + window.pageYOffset - 80, behavior: "smooth" });
      });
      ergebnis.querySelector(".sv-ergebnis").appendChild(neu);
      window.scrollTo({ top: wurzel.getBoundingClientRect().top + window.pageYOffset - 80, behavior: "smooth" });
    }

    function fehlerText(code) {
      if (code === "zu_viele") return notText("fehler_zu_viele");
      if (code === "nicht_gefunden") return notText("fehler_nicht_gefunden");
      if (code === "kontakt") return notText("fehler_kontakt");
      if (code === "leer") return notText("fehler_leer");
      return notText("fehler_technik");
    }

    function holen(url, optionen) {
      return fetch(url, optionen).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (d) {
          if (!r.ok || d.fehler) throw { code: d.fehler || "technik" };
          return d;
        });
      });
    }

    function abfrage(url, optionen, feld) {
      laden();
      holen(url, optionen).then(zeigen).catch(function (e) {
        formZeigen(fehlerText(e && e.code), e && e.code === "kontakt" ? "kontakt" : (e && e.code === "nicht_gefunden" ? feld : null));
      });
    }

    function formularBauen() {
      kopf.innerHTML = '<h1 class="sv-titel">' + esc(ui.titel) + '</h1><p class="sv-unter">' + esc(ui.unterzeile) + "</p>";
      form.innerHTML =
        '<div class="sv-feld"><label for="sv-nummer">' + esc(ui.feld_nummer) + '</label><input id="sv-nummer" name="nummer" autocomplete="off" inputmode="text" placeholder="' + esc(ui.feld_nummer_platzhalter) + '" required></div>' +
        '<div class="sv-feld"><label for="sv-kontakt">' + esc(ui.feld_kontakt) + '</label><input id="sv-kontakt" name="kontakt" autocomplete="email" inputmode="email"></div>' +
        '<p class="sv-meldung" data-meldung role="alert" hidden></p>' +
        '<button class="sv-knopf" type="submit">' + esc(ui.knopf) + "</button>";
      var vor = params.get("order") || params.get("bestellung");
      if (vor) form.querySelector('[name="nummer"]').value = vor.replace(/[^0-9A-Za-z#]/g, "");
    }

    form.addEventListener("submit", function (ev) {
      ev.preventDefault();
      var nummer = form.querySelector('[name="nummer"]').value.trim();
      var kontakt = form.querySelector('[name="kontakt"]').value.trim();
      if (!nummer) return formZeigen(notText("fehler_leer"), "nummer");
      var reine = nummer.replace(/^#/, "");
      if (/^\d{1,8}$/.test(reine) && !kontakt) return formZeigen(notText("fehler_kontakt"), "kontakt");
      var knopf = form.querySelector(".sv-knopf");
      knopf.disabled = true;
      knopf.innerHTML = '<span class="sv-kreis" aria-hidden="true"></span>' + esc(ui.laden);
      holen(api + "/api/suche", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ nummer: nummer, kontakt: kontakt, sprache: seitenSprache, markt: markt })
      }).then(function (d) {
        if (/^\d{1,8}$/.test(reine)) history.replaceState(null, "", location.pathname + "?order=" + encodeURIComponent(reine));
        zeigen(d);
      }).catch(function (e) {
        formZeigen(fehlerText(e && e.code), e && e.code === "kontakt" ? "kontakt" : "nummer");
      }).then(function () {
        knopf.disabled = false;
        knopf.textContent = ui.knopf;
      });
    });

    laden();
    kopf.hidden = true;
    form.hidden = true;
    holen(api + "/api/texte?sprache=" + encodeURIComponent(seitenSprache) + "&markt=" + encodeURIComponent(markt))
      .then(function (d) { ui = d.ui; })
      .catch(function () { ui = null; })
      .then(function () {
        if (!ui) {
          ergebnis.innerHTML = '<p class="sv-meldung" role="alert">' + esc(notText("fehler_technik")) + "</p>";
          return;
        }
        formularBauen();
        var o = params.get("o"), k = params.get("k"), n = params.get("nums") || params.get("n");
        var q = "&sprache=" + encodeURIComponent(seitenSprache) + "&markt=" + encodeURIComponent(markt);
        if (o && k) return abfrage(api + "/api/link?o=" + encodeURIComponent(o) + "&k=" + encodeURIComponent(k) + q, {}, "nummer");
        if (n) return abfrage(api + "/api/sendung?n=" + encodeURIComponent(n.split(",")[0]) + q, {}, "nummer");
        formZeigen();
      });
  }

  function init() {
    document.querySelectorAll("[data-sendungsverfolgung]").forEach(function (w) {
      if (!w.getAttribute("data-bereit")) {
        w.setAttribute("data-bereit", "1");
        start(w);
      }
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
